import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import DropDownInput from "../DropDownInput/DropDownInput";
import { sortOptions } from "modules/search/config/formOptions";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { filters } from "modules/search/dummy/filtros.js";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Axios from 'services/BackendApi/BackendApi';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import app_params from "modules/search/config/params";
import { useSearchParams } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

const SearchFilters = () => {
  const [selectedEnterprise, setSelectedEnterprise] = useState();
  const [selectedReception, setSelectedReception] = useState("");
  const [selectedDoctype, setSelectedDoctype] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [recepciones, setRecepciones] = useState([]);
  const [enterprises, setEnterprises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [docytpes, setDoctypes] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [fechaI, setFechaI] = useState([]);
  const [fechaF, setFechaF] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [languages, setLanguages] = useState([]);
  const { search } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [searchType, setSearchType] = useState("fulltext");
  const [show, setShow] = useState(true);


  useEffect(() => {
    if (loading) {
      setMaterials(filters.materials);
      setLanguages(filters.languages);
      getData(undefined);
    }
  }, []);
  
  useEffect(() => {
    var empresa = selectedEnterprise?.value;
    if (empresa!=undefined) {
      empresa = empresa.replace('enterprise-', '')
      getData(empresa);
    }
  }, [selectedEnterprise]);

  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef();

  useEffect(() => {
    const storedInputValue = localStorage.getItem('inputValue');
    if (storedInputValue) {
      setInputValue(storedInputValue);
    }
  }, []);

  useEffect(() => {
    // Almacenar el valor del input en localStorage cuando cambia
    localStorage.setItem('inputValue', inputValue);
  }, [inputValue]);

  const handleInputChange = (newValue, { action }) => {
    if (action === 'input-change') {
      setInputValue(newValue);
    }
  };

  const handleChange = (e) => {
    setSelectedReception(e);
    setInputValue(''); // Limpiar el input después de seleccionar una opción
  };


  // useEffect(() => {
  //   var urlValue = searchParams.get("fulltext");
  //   if (urlValue) {
  //     setSearchText(urlValue);
  //   }
  //   // var urlDate = searchParams.get("documentdate");
  //   // if (urlDate) {
  //   //   console.log(urlDate)
  //   //   urlDate= "["+urlDate+"T00:00:00Z TO *]"
  //   //   searchParams.set("documentdate",urlDate);
  //   //   window.location.search=searchParams.toString();
  //   // }
  //   // console.log(searchParams.get("documentdate"))
  // }, [searchParams]);

  useEffect(() => {
    if (!loading) {
      const groupParamsByKey = (params) =>
        [...params.entries()].reduce((acc, [key, val]) => {
          if (acc.hasOwnProperty(key)) {
            // if the current key is already an array, we push the value to it
            if (Array.isArray(acc[key])) {
              acc[key] = [...acc[key], val];
            } else {
              // if it's not an array, we will convert it into an array and add the current value to it
              acc[key] = [acc[key], val];
            }
          } else if (val !== '') {
            // plain assignment if no special case is present
            acc[key] = [val];
          }

          return acc;
        }, {});
      const paramsToObject = (params) => {
        try {
          const urlParams = new URLSearchParams(params);
          const paramsObj = groupParamsByKey(urlParams);
          return paramsObj;
        } catch (e) {
          // console.log(e);
          return {};
        }
      };

      const params = paramsToObject(search);
      // console.log(params)
      if (params?.doctype) {
        var documentos = docytpes.find((item) => item?.code == params.doctype)
        setSelectedDoctype(
          { label: documentos.name, value: documentos.code }
        );
      }
      if (params?.hierarchy) {
        var aux = params.hierarchy[0]
        // console.log(aux)
        var empresas = enterprises.find((item) => item?.erp_code == aux.replace('enterprise-', ''))//Quitarle el "-enterprise para que haga match"
        setSelectedEnterprise(
          { label: empresas?.name, value: "enterprise-" + empresas?.erp_code }
        );
        // getData(empresas?.erp_code)
      }
      if (params?.typefiedid) {
        var aux = params.typefiedid[0]
        var cuenta = cuentas.find((item) => item?.bank_account_number == aux.replace('bank-account-', ''))//Quitarle el "-enterprise para que haga match"
        setSelectedAccount(
          { label: cuenta?.bank_account_number, value: 'bank-account-' + cuenta?.bank_account_number }
        );
      }
      if (params?.identifier) {
        var aux = params.identifier[0]
        setSearchText(params.identifier[0]);

      }
      if (params?.reception) {
        var aux = params.reception[0]
        var recepcion = recepciones.find((item) => item?.code == aux)
        setSelectedReception(
          { label: recepcion?.code, value: recepcion?.code }
        );

      }
      if (params?.documentdatei) {
        var aux = params.documentdatei[0]
        setFechaI(aux);
      }
      if (params?.documentdatef) {
        var aux = params.documentdatef[0]
        setFechaF(aux);
      }
    }

  }, [search, loading]);

  async function getData(id) {
    console.log(selectedEnterprise)

    let docs = await Axios.GetDocTypes({ urlParams: "1" });
    setDoctypes(docs.data)
    let code = await Axios.GetEmpresas({ urlParams: "1" });
    // console.log(code);
    setEnterprises(code.data)
    let accounts = await Axios.GetCuentas({ urlParams: {id} });
    setCuentas(accounts.data)
    let recep_codes = await Axios.receptionCodes({ urlParams: "1" });
    console.log(recep_codes);
    // let aux = res.data.query_result.models_1.queryOneModel_1.result[0]
    // let code = aux.code;
    // setBuscar(code);
    setRecepciones(recep_codes.data.freeSQL_result.result)
    setLoading(false);
  }

  function borrar() {
    setSelectedEnterprise("")
    setSelectedDoctype("")
    setSelectedAccount("")
    window.location.href = `${app_params.basepath}/search`;
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 mb-3 form-group">
          <label htmlFor="enterprise"><b>Empresa:</b>
            <OverlayTrigger
              key='right'
              placement='right'
              overlay={
                <Tooltip id={`tooltip-right`}>
                  Listado de las empresas, clasificadas por nombre y código
                </Tooltip>
              }
            >
              <Button variant="light"><QuestionCircleFill /></Button>
            </OverlayTrigger></label>
          <Select
            isLoading={loading}
            name="hierarchy"
            options={enterprises?.map((enterprise) => ({
              label: enterprise?.name + "(" + enterprise?.erp_code + ")",
              value: 'enterprise-' + enterprise?.erp_code,
            }))}
            value={selectedEnterprise}
            onChange={(e) => setSelectedEnterprise(e)}
            placeholder="Todas las empresas"
          />
        </div>
        <div className="col-12 mb-3 form-group">
          <label htmlFor="doctype"><b>Tipo de Documento:</b>
            <OverlayTrigger
              key='right'
              placement='right'
              overlay={
                <Tooltip id={`tooltip-right`}>
                  Listado de los distintos tipos de documentos que se maneja en el archivo
                </Tooltip>
              }
            >
              <Button variant="light"><QuestionCircleFill /></Button>
            </OverlayTrigger></label>
          <Select
            isLoading={loading}
            name="doctype"
            options={docytpes?.map((doctype) => ({
              label: doctype?.name,
              value: doctype?.code,
            }))}
            value={selectedDoctype}
            onChange={(e) => setSelectedDoctype(e)}
            placeholder="Todas los Documentos"
          />
        </div>
        {(selectedDoctype.value == "C8" || selectedDoctype.value == "CL" ||
          selectedDoctype.value == "C9" || selectedDoctype.value == "ND" ||
          selectedDoctype.value == "EC"
        ) ?

          <div className="col-12 mb-3 form-group">
            <label htmlFor="typefiedid"><b>Cuenta:</b>
              <OverlayTrigger
                key='right'
                placement='right'
                overlay={
                  <Tooltip id={`tooltip-right`}>
                    Listado de las cuentas, solamente aplica para ciertos tipos de documentos
                  </Tooltip>
                }
              >
                <Button variant="light"><QuestionCircleFill /></Button>
              </OverlayTrigger></label>
            <Select
              isLoading={loading}
              name="typefiedid"
              options={cuentas?.map((cuenta) => ({
                label: cuenta?.bank_account_number + "-" + cuenta?.currency,
                value: 'bank-account-' + cuenta?.bank_account_number,
              }))}
              value={selectedAccount}
              onChange={(e) => setSelectedAccount(e)}
              placeholder="Todas las cuentas"
            />
          </div> : null
        }
        <div className="col-12 mb-3 form-group">
          <label htmlFor="fechaI"><b>Fecha inicio</b>
            <OverlayTrigger
              key='right'
              placement='right'
              overlay={
                <Tooltip id={`tooltip-right`}>
                  Aquí se coloca una fecha de inicio para buscar documentos desde cierta fecha
                </Tooltip>
              }
            >
              <Button variant="light"><QuestionCircleFill /></Button>
            </OverlayTrigger></label>
          <input
            style={{ height: '40px', paddingLeft: '10px' }}
            type="date"
            className={`form-control`}
            placeholder="fechaI"
            aria-label="Buscar"
            aria-describedby="basic-addon2"
            id="fechaI"
            name="documentdatei"
            autoComplete="off"
            value={fechaI}
            // value={"["+fechaI+"T00:00:00Z TO *]"}
            onChange={(e) => setFechaI(e.target.value)}
          />
        </div>
        <div className="col-12 mb-3 form-group">
          <label htmlFor="fechaF"><b>Fecha Fin</b>
            <OverlayTrigger
              key='right'
              placement='right'
              overlay={
                <Tooltip id={`tooltip-right`}>
                  Aquí se coloca una fecha de fin para limitar el rango de fechas del documento a buscar
                </Tooltip>
              }
            >
              <Button variant="light"><QuestionCircleFill /></Button>
            </OverlayTrigger></label>
          <input
            style={{ height: '40px', paddingLeft: '10px' }}
            type="date"
            className={`form-control`}
            placeholder="fechaF"
            aria-label="Buscar"
            aria-describedby="basic-addon2"
            id="fechaF"
            name="documentdatef"
            autoComplete="off"
            value={fechaF}
            onChange={(e) => setFechaF(e.target.value)}
          />
        </div>
        <div className="col-12 mb-3 form-group">
          <label htmlFor="identifier"><b>Identificador: (No. SAP, No. Documento, etc)</b>
            <OverlayTrigger
              key='right'
              placement='right'
              overlay={
                <Tooltip id={`tooltip-right`}>
                  Los identificadores son datos que identifican el documento como por ejemplo:
                  Número SAP, Numero de documento, Numero de factura, etc
                </Tooltip>
              }
            >
              <Button variant="light"><QuestionCircleFill /></Button>
            </OverlayTrigger></label>
          <input
            style={{ height: '40px', textIndent: '10px' }}
            type="text"
            className={`form-control`}
            placeholder="Id"
            aria-label="Buscar"
            aria-describedby="basic-addon2"
            id="searchId"
            name="identifier"
            autoComplete="off"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="col-12 mb-3 form-group">
          <label htmlFor="reception"><b>Recepción:</b>
            <OverlayTrigger
              key='right'
              placement='right'
              overlay={
                <Tooltip id={`tooltip-right`}>
                  Listado de las recepciones realizadas en el modulo de Recepción
                </Tooltip>
              }
            >
              <Button variant="light"><QuestionCircleFill /></Button>
            </OverlayTrigger></label>
          <Select
            isLoading={loading}
            name="reception"
            options={recepciones?.map((recepcion) => ({
              label: recepcion?.code,
              value: recepcion?.code,
            }))}
            inputValue={inputValue}
            value={selectedReception}
            onChange={handleChange}
            onInputChange={handleInputChange}
            placeholder="Todas las entregas"
          />
        </div>
        {/* <div className="col-12 form-group">
          <label htmlFor="material">Material:</label>
          <Select
            isLoading={loading}
            isMulti
            name="material"
            options={materials?.map((material) => ({
              label: material?.name,
              value: material?.value,
            }))}
            value={selectedMaterial}
            onChange={(e) => {
              setSelectedMaterial(e);
            }}
            placeholder="Todos los materiales"
          />
        </div> */}
      </div>
      {/* <hr />
      <div className="row">
        <div className="col-12 form-group">
          <label htmlFor="sortby">Ordenar por:</label>
          <DropDownInput name="sortby" options={sortOptions} />
        </div>
      </div> */}
      <hr />
      <div className="row">
        <div className="col-12">
          <Button variant="primary" type="submit" className="col-12">
            Aplicar filtros
          </Button>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12">
          <Button variant="warning" onClick={borrar} className="col-12">
            Borrar filtros
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchFilters;
